import * as api from "@/api/version";
import { useQuery } from "react-query";

export function useVersion() {
  return useQuery("version", api.getVersionInfo, {
    staleTime: Infinity,
  });
}
